import { Injectable } from '@angular/core';
import { LifeStyleQuestion, Sections, rangeData, ErrorMsgModel, conversionChangeModel, diabetesConversionChangeModel, DateDropdownQuestionsListModel } from '../model/lifestyle.model';
import { SyncService } from './sync.service';
import { UnderWritingData, QuestionsToAPI } from '../model/lifestyle.post.model';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { Router, NavigationEnd, RouterEvent } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MEDICAL_UW_URL, MEDICAL_UW_HO_URL, UW_WEB_ANALYTICS_CONST, BRMS_WEB_ANALYTICS_CONST_LIST } from 'src/app/shared/constants/medical-uw-url.constants';
import { MedicationQuestionStoreModel, CurrentMedConToDisplay, AccordQuestionStoreModel, tabSquareActiveModel, InvalidCtlNameObj } from '../model/mcUserJourney.model';
const MEDICATION = "Medication";
import * as converter from 'convert-units';
import { AnnuitantMedicalConditions } from 'src/app/pages/medical-underwriting/model';
import { MedicalCondQuestionSet, MedicalDashboardStatus } from '../medical-underwrting.constants';
@Injectable({
  providedIn: 'root'
})
export class UtilityServiceForMedicalService {
  private sectionsListObj: Sections[];
  private sectionsListObjForMedication: Sections[];
  private rangeValidationData: rangeData[];
  private newToggleOption: any;
  private newConfigObj: LifeStyleQuestion;
  checkForId: boolean = false;
  private medicalUW_URLs = MEDICAL_UW_URL;
  currentUWScreenName: string = null;
  conversionChangeObj = new conversionChangeModel();
  diabetesConversionChangeObj = new diabetesConversionChangeModel();
  recurrenceBackendJsonList: QuestionsToAPI[] = [];
  idListToSendApi: string[] = [];
  private dateDropdownQuestionsList: DateDropdownQuestionsListModel = new DateDropdownQuestionsListModel();

  constructor(private syncService: SyncService,
    private router: Router) {

    router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      // tslint:disable-next-line: max-line-length
      let currentUrl = event.url.includes("?") ? event.url.split("?")[0] : event.url;
      if (Object.values(this.medicalUW_URLs.annuitant).indexOf(currentUrl) > -1 || Object.values(MEDICAL_UW_HO_URL.annuitant).indexOf(currentUrl) > -1) {
        this.currentUWScreenName = 'annuitant';
        // tslint:disable-next-line: max-line-length
      } else if (Object.values(this.medicalUW_URLs.dependant).indexOf(currentUrl) > -1 || Object.values(MEDICAL_UW_HO_URL.dependant).indexOf(currentUrl) > -1) {
        this.currentUWScreenName = 'dependant';
      } else {
        this.currentUWScreenName = null;
      }
    });

    this.syncService.getMedicalConditionJson().subscribe((res) => {
      this.sectionsListObj = res;
    });
    this.syncService.getMedicationJson().subscribe((res) => {
      this.sectionsListObjForMedication = res;
    });
    this.syncService.getRangeValidationJson().subscribe((res) => {
      this.rangeValidationData = res;
    });
  }

  getNumberOfSameIndexInstance(questionModels): number {
    let numberOfTabs = 1;
    let duplicateIndex = "0";
    questionModels.forEach(element => {
      if (duplicateIndex === element.index) {
        // eg: 0th of element index can be duplicated.
      }
      else {
        numberOfTabs++;
        duplicateIndex = element.index;
      }
    });
    return numberOfTabs;
  }

  getAnswerFromStore(questionId: string): QuestionsToAPI {
    let value: QuestionsToAPI;
    let temp = this.syncService.getPayLoadObjAndIndexFromStore();
    if (temp) {
      value = this.getResponseValuesFromStore(questionId, temp.payloadObj, temp.indexNumberToSearch);
      return value;
    }
    return null;

  }

  validateFormForTabSquareQuesList(tabObj: tabSquareActiveModel, parentForm: UntypedFormGroup, jsonSectionToRefer: string, accordionIndex: number): boolean {
    let isValid = true;
    for (let item in tabObj.nextQuestionObjList) {
      let nextQuesObj = tabObj.nextQuestionObjList[item];
      isValid = this.recursiveFunToValidateForm(nextQuesObj, parentForm, jsonSectionToRefer, accordionIndex);
      if (!isValid) {
        break;
      }
      if (isValid) {
        let idList: string[] = [];
        if(tabObj.jsonToRefer === MEDICATION){ 
          idList = this.getMedQuestionIdListSelectedValue(nextQuesObj.responseValueByUser, nextQuesObj.id);
        }
        else{
          idList = this.getNextQuestionsIdListSelectedValue(nextQuesObj.responseValueByUser, nextQuesObj.id);
        }
        
        if (idList && idList.length > 0) {
          let tempNextObjList: LifeStyleQuestion[] = [];
          if(tabObj.jsonToRefer){
            tempNextObjList = this.getMedicationQuestionListForGivenIds(idList, jsonSectionToRefer);
          }
          else{
            tempNextObjList = this.getQuestionListForGivenIds(idList, jsonSectionToRefer);
          }
          if (tempNextObjList && tempNextObjList.length > 0) {
            tempNextObjList.forEach(nextQues => {
              isValid = this.recursiveFunToValidateForm(nextQues, parentForm, jsonSectionToRefer, accordionIndex);
              if (!isValid) {
                return isValid;
              }
            });
          }
        }

      }
    }
    return isValid;
  }

  recursiveFunToValidateForm(nextQuestionObj: LifeStyleQuestion, parentForm: UntypedFormGroup, jsonSectionToRefer: string, accordionIndex: number) {
    let isValid = true;
    let idToLookFor: string = nextQuestionObj.id;
    let formName = this.getControlName(idToLookFor, accordionIndex);
    if ((parentForm.controls[formName] &&
      (parentForm.controls[formName].errors || !parentForm.controls[formName].valid)) ||
      ((nextQuestionObj.controlStyle === "DropDown_date") && parentForm.controls[formName].get(formName) &&
        parentForm.controls[formName].get(formName).errors)) {
      isValid = false;
      if (!isValid) {
        return isValid;
      }
      else {
        let idList = this.getMedQuestionIdListSelectedValue(nextQuestionObj.responseValueByUser, idToLookFor);
        let tempNextObjList: LifeStyleQuestion[] = this.getMedicationQuestionListForGivenIds(idList, jsonSectionToRefer);
        if (tempNextObjList && tempNextObjList.length > 0) {
          tempNextObjList.forEach(nextQues => {
            isValid = this.recursiveFunToValidateForm(nextQues, parentForm, jsonSectionToRefer, accordionIndex);
            if (!isValid) {
              return isValid;
            }
          });

        }
      }
    }

    return isValid;
  }

  getQuestionsModelForTabSquareFromAccord(objToReferForAccord: AccordQuestionStoreModel, tabSquareQuesId: string): QuestionsToAPI[] {
    let quesModelForTabSquare: QuestionsToAPI[] = null;
    if (objToReferForAccord && objToReferForAccord.questionList) {
      objToReferForAccord.questionList.forEach(element => {
        if (element.id === tabSquareQuesId) {
          quesModelForTabSquare = element.questionModels;
        }
      });
    }
    return quesModelForTabSquare;
  }

  getResponseValueFromRefObj(objToReferForAccord: AccordQuestionStoreModel, quesId: string, accordIndexToAppend: number): string {
    let responseValueFromStore = null;
    if (objToReferForAccord && (objToReferForAccord.accordionIndex === accordIndexToAppend)) {
      let result = objToReferForAccord.questionList.find((item) => item.id === quesId);
      if (result && result.responseValue) {
        responseValueFromStore = result.responseValue;
      }
    }
    return responseValueFromStore;
  }

  getdateDropdownMatchingQuestionFromList(question: LifeStyleQuestion, dateType: string): LifeStyleQuestion {
    let questionObj: LifeStyleQuestion = null;
    let isTreatmentOrigoElemToBeCompared = false;
    let typeOfTreatment: string;
    if(question.origoElement.includes("type~")){ // this is not right solution 
      isTreatmentOrigoElemToBeCompared = true;
      let temp = question.origoElement.split("|");
      typeOfTreatment = temp[0];   
    }
    if (this.currentUWScreenName === 'annuitant') {
      if (this.dateDropdownQuestionsList && this.dateDropdownQuestionsList.annuitant && this.dateDropdownQuestionsList.annuitant.length > 0) {
        if(isTreatmentOrigoElemToBeCompared){
          questionObj = this.dateDropdownQuestionsList.annuitant.find(ques => question.origoSection === ques.origoSection && (ques.origoElement.includes(typeOfTreatment)) && (ques.origoElement.includes(dateType)) && ques.responseValueByUser !== null);
        }
        else{
          questionObj = this.dateDropdownQuestionsList.annuitant.find(ques => question.origoSection === ques.origoSection && (ques.origoElement.includes(dateType)) && ques.responseValueByUser !== null);
        }
      }
    } else if (this.currentUWScreenName === 'dependant') {
      if (this.dateDropdownQuestionsList && this.dateDropdownQuestionsList.dependant && this.dateDropdownQuestionsList.dependant.length > 0) {
        if(isTreatmentOrigoElemToBeCompared){
          questionObj = this.dateDropdownQuestionsList.dependant.find(ques => question.origoSection === ques.origoSection && (ques.origoElement.includes(typeOfTreatment)) && (ques.origoElement.includes(dateType)) && ques.responseValueByUser !== null);
        }
        else{
          questionObj = this.dateDropdownQuestionsList.dependant.find(ques => question.origoSection === ques.origoSection && (ques.origoElement.includes(dateType)) && ques.responseValueByUser !== null);
        }
      }
    }
    return questionObj;
  }

  setdateDropdownQuestionToList(question: LifeStyleQuestion) {
    if (this.currentUWScreenName === 'annuitant') {
      if (this.dateDropdownQuestionsList && this.dateDropdownQuestionsList.annuitant && this.dateDropdownQuestionsList.annuitant.length > 0) {
        let index = this.dateDropdownQuestionsList.annuitant.findIndex(ques => ques.id === question.id);
        if (index > -1) {
          this.dateDropdownQuestionsList.annuitant[index].responseValueByUser = question.responseValueByUser;
        } else {
          this.dateDropdownQuestionsList.annuitant.push(question);
        }
      } else {
        this.dateDropdownQuestionsList.annuitant.push(question);
      }
    } else if (this.currentUWScreenName === 'dependant') {
      if (this.dateDropdownQuestionsList && this.dateDropdownQuestionsList.dependant && this.dateDropdownQuestionsList.dependant.length > 0) {
        let index = this.dateDropdownQuestionsList.dependant.findIndex(ques => ques.id === question.id);
        if (index > -1) {
          this.dateDropdownQuestionsList.dependant[index].responseValueByUser = question.responseValueByUser;
        } else {
          this.dateDropdownQuestionsList.dependant.push(question);
        }
      } else {
        this.dateDropdownQuestionsList.dependant.push(question);
      }
    }
  }

  getControlName(quesId: string, accordIndexToAppend: number): string {
    let controlName: string;
    controlName = quesId;
    if (accordIndexToAppend === 0 || accordIndexToAppend) {
      controlName = 'A' + accordIndexToAppend + '-' + controlName;
    }
    return controlName;
  }

  getControlNameWithAccordAndTabIndex(quesId: string, accordIndexToAppend: number, tabSquareIndexToAppend: number): string {
    let controlNameToSet: string;
    controlNameToSet = quesId;
    if (accordIndexToAppend === 0 || accordIndexToAppend) {
      controlNameToSet = 'A' + accordIndexToAppend + '-' + controlNameToSet;
    }
    if (tabSquareIndexToAppend === 0 || tabSquareIndexToAppend) {
      controlNameToSet = controlNameToSet + '-' + tabSquareIndexToAppend;
    }
    return controlNameToSet;
  }


  getAccordionPrefix(quesId: string, accordIndexToAppend: number): string {
    let accordionPrefix: string;
    accordionPrefix = quesId;
    if (accordIndexToAppend === 0 || accordIndexToAppend) {
      accordionPrefix = 'A' + accordIndexToAppend + '-' + accordionPrefix;
    }
    return accordionPrefix;
  }

  getAccordionWithoutQuesIdPrefix(accordIndexToAppend: number): string {
    let accordionPrefix: string;
    if (accordIndexToAppend === 0 || accordIndexToAppend) {
      accordionPrefix = 'A' + accordIndexToAppend + '-';
    }
    else {
      accordionPrefix = null;
    }
    return accordionPrefix;
  }

  getDomId(quesId: string, accordIndexToAppend: number, tabSquareIndexToAppend: number): string {
    let domId: string;
    domId = quesId;
    if (accordIndexToAppend === 0 || accordIndexToAppend) {
      domId = 'A' + accordIndexToAppend + '-' + domId;
    }
    if (tabSquareIndexToAppend === 0 || tabSquareIndexToAppend) {
      domId = domId + '-' + tabSquareIndexToAppend;
    }
    return domId;
  }

  getUnderWritingNavigationURL(annuitantURL: string, dependantURL: string) {
    if (this.currentUWScreenName === 'annuitant') {
      return annuitantURL;
    } else if (this.currentUWScreenName === 'dependant') {
      return dependantURL;
    } else {
      return null;
    }
  }

  getUserSelectedValueFromFormObj(formObj: UntypedFormGroup, questionObj: LifeStyleQuestion, prefixToAddInFormCtl: string): any {
    let selectedValue: any;
    let controlNameToGetValue: string;
    if (questionObj.controlStyle === "CheckBox_standard" || questionObj.controlStyle === "CheckBox_withSubquestions_DropDown_standard" || questionObj.controlStyle === "CheckBox_withSubquestions") {
      controlNameToGetValue = questionObj.id + 'checkbox';
    }
    else {
      controlNameToGetValue = questionObj.id;
    }
    if (prefixToAddInFormCtl) {
      controlNameToGetValue = prefixToAddInFormCtl + controlNameToGetValue;
    }

    if (formObj.value) {
      selectedValue = formObj.value[controlNameToGetValue];
      if (selectedValue === typeof "string" || selectedValue === null) {
        return selectedValue;
      }
      else {
        selectedValue = this.getValueFromNestedFormObj(formObj.value, controlNameToGetValue);
        return selectedValue;
      }
    }

  }


  getValueFromNestedFormObj(givenObj: any, quesid: string): any {

    let objToLoop = givenObj[quesid];  // in 1st time this could be obj
    if (typeof objToLoop === "string" || objToLoop === null) {
      return objToLoop;
    }
    if (objToLoop === undefined && typeof givenObj === "object") { // nested level loop
      for (let j in givenObj) {
        if (givenObj.hasOwnProperty(j)) {
          let value = givenObj[j];
          if (value && typeof value === "object" && value.hasOwnProperty(quesid)) {
            return this.getValueFromNestedFormObj(value, quesid);
            break;
          }
        }

      }
    }
    else { // parent level loop
      for (let i in objToLoop) {
        if (objToLoop.hasOwnProperty(i)) {
          if (quesid === i) {
            if (typeof objToLoop[i] === "string" || objToLoop[i] === null) {
              return objToLoop[i];
              break;
            }
            else {
              let value = this.getValueFromNestedFormObj(objToLoop[i], quesid);
              if (typeof value === "string" || value === null) {
                return value;
                break;
              }
            }
          }
        }
      }
    }
  };

  prepareBackendJson(formObj: UntypedFormGroup, questionObj: LifeStyleQuestion, prefixToAddInFormCtl: string): QuestionsToAPI {
    const questionSet = new QuestionsToAPI();
    questionSet.id = questionObj.id;
    questionSet.origoSection = questionObj.origoSection;
    questionSet.origoElement = questionObj.origoElement;
    questionSet.origoAttribute = questionObj.origoAttribute;
    questionSet.specialInstructions = questionObj.specialInstructions;
    questionSet.mandatoryResponse = questionObj.mandatoryResponse;
    questionSet.responseValue = this.getUserSelectedValueFromFormObj(formObj, questionObj, prefixToAddInFormCtl);
    return questionSet;
  }

  setResponseValueAsNullForAllNextQues(nextQuestionList: LifeStyleQuestion[], jsonToReferFromSyncService: string): void {
    nextQuestionList.forEach(element => {
      element.responseValueByUser = null;
      if (element.nextStep) {
        element.nextStep.forEach(obj => { // this function is called recursively go depth of next question and reset the value for response value as null. eg: LS grid questions
          if (obj.nextStepValue && obj.nextStepType === "Question") {
            let nestedLevelNextQuesObjList: LifeStyleQuestion[] = this.getQuestionListForGivenIds(obj.nextStepValue, jsonToReferFromSyncService);
            if (nestedLevelNextQuesObjList && nestedLevelNextQuesObjList.length > 0) {
              this.setResponseValueAsNullForAllNextQues(nestedLevelNextQuesObjList, jsonToReferFromSyncService);
            }
          }
        });
      }
    });

  }

  removeUnwantedFormControl(quesIdListToSend: string[], accordIndexValueToRemove, formObj: UntypedFormGroup) {
    let controlNameList: string[] = Object.keys(formObj.controls);
    if (quesIdListToSend && controlNameList) {
      controlNameList.forEach(ctName => {
        if (ctName.includes("checkbox") || ctName.includes("lifestyleRiskWarningQuestion")) { // we can ignore checkbox and not required to remove from the formObj as no validation rule set for checkbox

        }        
        else if (!this.checkIfCtlNameFoundInPayload(quesIdListToSend, ctName) ||
        ((ctName==='DIQ014' && formObj.controls['DIQ015'] && formObj.controls['DIQ015'].value) || 
        (ctName==='DIQ015' && formObj.controls['DIQ014'] && formObj.controls['DIQ014'].value))) {
        formObj.removeControl(ctName);
        }
      });
    }
    let controlNameListUpdated: string[] = Object.keys(formObj.controls);
  }

  checkIfCtlNameFoundInPayload(quesIdListToSend: string[], idToMatch: string): boolean {
    let matchFound = false;
    quesIdListToSend.forEach(element => {

      if (element === idToMatch) {
        matchFound = true;
      }
    });
    return matchFound;
  }

  transformIdsBackToExistingAccordionTabs(idList: string[], indexListToLookFor: number[]): string[] {
    let prefixList: string[] = [];
    idList.forEach(element => {
      if (element.includes("A") && element.includes("-")) {
        let temp = element.split("-");
        prefixList.push(temp[0]);
      }
    });
    let uniquePrefixListFromPayLoad = prefixList.filter(function (elem, index, self) {
      return index === self.indexOf(elem);
    });

    let indexListToLookForWithPrefix = [];
    indexListToLookFor.forEach(element => {
      indexListToLookForWithPrefix.push('A' + element);
    });
    if ((indexListToLookForWithPrefix.length === uniquePrefixListFromPayLoad.length) &&
      JSON.stringify(indexListToLookForWithPrefix) == JSON.stringify(uniquePrefixListFromPayLoad)) {
      // no transformation required here
    }
    else if (indexListToLookForWithPrefix.length === uniquePrefixListFromPayLoad.length) {
      let newTransformedIdList: string[] = [];
      indexListToLookForWithPrefix.forEach((prefixToBeTransformed, index) => {
        let prefixToChange = uniquePrefixListFromPayLoad[index];
        idList.forEach(idToChange => {
          if (!idToChange.includes("A")) {
            newTransformedIdList.push(idToChange);
          }
          if (idToChange.includes(prefixToChange)) {
            let temp = idToChange.split('-');
            idToChange = prefixToBeTransformed + '-' + temp[1];
            newTransformedIdList.push(idToChange);
          }

        });
      });
      let newTransformedIdListUnique = newTransformedIdList.filter(function (elem, index, self) {
        return index === self.indexOf(elem);
      });
      idList = newTransformedIdListUnique;
    }
    else {

    }
    return idList;
  }

  getQuesIdListToSend(payloadList: QuestionsToAPI[], accordionQuesId: string): string[] {
    this.idListToSendApi = [];
    payloadList.forEach(element => {
      this.idListToSendApi.push(element.id);
      let isAccordionPresent = (element.id === accordionQuesId) ? true : false;
      if (element.questionModels && element.questionModels.length > 0) {
        element.questionModels.forEach(qmObj => {
          this.prepareQuesIdListToSend(qmObj, isAccordionPresent, qmObj.index);
        });
      }
    });
    let uniqueIdListFromPayLoad = this.idListToSendApi.filter(function (elem, index, self) {
      return index === self.indexOf(elem);
    });
    let indexListToLookFor = this.syncService.getAccordIndexToPrepareBackEndJson();
    if (accordionQuesId && indexListToLookFor) {
      uniqueIdListFromPayLoad = this.transformIdsBackToExistingAccordionTabs(uniqueIdListFromPayLoad, indexListToLookFor);
    }
    return uniqueIdListFromPayLoad;

  }

  prepareQuesIdListToSend(payloadObj: QuestionsToAPI, isAccordionPresent: boolean, indexToAppend: string) {
    let tempId = isAccordionPresent ? (this.getControlName(payloadObj.id, Number(indexToAppend))) : payloadObj.id;
    this.idListToSendApi.push(tempId);
    if (payloadObj.questionModels && payloadObj.questionModels.length > 0) {
      payloadObj.questionModels.forEach(qmObj => {
        this.prepareQuesIdListToSend(qmObj, isAccordionPresent, indexToAppend); // this is nested level index which we should ignore. we should pass the parent level index
      });
    }
  }

  getQuestionListForGivenIds(questionList: string[], jsonToReferFromSyncService: string): LifeStyleQuestion[] {
    let listOfMatchingQuestions = [];
    questionList.forEach(givenQues => {
      if (jsonToReferFromSyncService === MEDICATION) {
        this.sectionsListObjForMedication.forEach(sec => {
          sec.question.forEach(ques => {
            if (ques.id === givenQues && ques.dcjCustomerDisplay === 'Yes') {
              listOfMatchingQuestions.push(ques);
            }
          });
        });
      }
      else {
        this.sectionsListObj.forEach(sec => {
          sec.question.forEach(ques => {
            if (ques.id === givenQues) {
              listOfMatchingQuestions.push(ques);
            }
          });
        });
      }
    });
    return listOfMatchingQuestions;

  }

  removedMandatoryResponseFromPayload(medicalConditionPayload: QuestionsToAPI[]): QuestionsToAPI[] {
    return medicalConditionPayload;

  }
  getsStatusOfMedCond(medicalConditionPayload: QuestionsToAPI[]): string {
    let status: string = MedicalDashboardStatus.completed;
    if (this.isMandatoryResponseNotAnswered(medicalConditionPayload)) {
      status = MedicalDashboardStatus.notCompleted;
    }
    return status;
  }

  isMandatoryResponseNotAnswered(medicalConditionPayload: QuestionsToAPI[]): boolean {
    let isMandatoryResponseNotAns = false;
    for (let item in medicalConditionPayload) {
      if ((medicalConditionPayload[item].mandatoryResponse === "Yes") && (!medicalConditionPayload[item].responseValue)) {
        isMandatoryResponseNotAns = true;
        break;
      }
      else if (medicalConditionPayload[item].questionModels && medicalConditionPayload[item].questionModels.length > 0) {
        let isMandatoryResponseNotAnsForDep = this.isMandatoryResponseNotAnswered(medicalConditionPayload[item].questionModels);
        if (isMandatoryResponseNotAnsForDep) {
          isMandatoryResponseNotAns = true;
          break;
        }
      }
    }
    return isMandatoryResponseNotAns;
  }

  getMedicationQuestionListForGivenIds(questionList: string[], jsonToReferFromSyncService: string): LifeStyleQuestion[] {
    let listOfMatchingQuestions = [];
    questionList.forEach(givenQues => {
      this.sectionsListObjForMedication.forEach(sec => {
        sec.question.forEach(ques => {
          if (ques.id === givenQues) {
            listOfMatchingQuestions.push(ques);
          }
        });
      });
    });
    return listOfMatchingQuestions;
  }

  getQuesIdListFromDummyQuestion(quesObj: LifeStyleQuestion): string[] {
    let quesIdList: string[] = []
    if (quesObj.responseType === "Dummy" && quesObj.nextStep)
      quesObj.nextStep.forEach(next => {
        next.nextStepValue.forEach(id => {
          quesIdList.push(id);
        });
      });
    return quesIdList;
  }

  getNextQuestionsIdListSelectedValue(userSelectedValue: string, givenQuestion: string): string[] {
    let nextQuestionsIdList: string[];
    this.sectionsListObj.forEach(sec => {
      sec.question.forEach(ques => {
        if (ques.id === givenQuestion && ques.nextStep) {
          ques.nextStep.forEach(next => {
            if (next.nextStepSelectedResponse === userSelectedValue) {
              nextQuestionsIdList = next.nextStepValue;
            }
          });
        }
        else if (ques.id === givenQuestion && ques.responseMethod && userSelectedValue === "Yes") {
          let medJsonResponse: string[] = [];
          medJsonResponse[0] = ques.responseMethod;
          nextQuestionsIdList = medJsonResponse;
        }
        else if (ques.id === givenQuestion && ques.responseMethod && userSelectedValue === "No") {
          nextQuestionsIdList = null;
        }
      });
    });
    return nextQuestionsIdList;
  }

  getMedQuestionIdListSelectedValue(userSelectedValue: string, givenQuestion: string): string[] {
    let nextQuestionsIdList: string[];
    this.sectionsListObjForMedication.forEach(sec => {
      sec.question.forEach(ques => {
        if (ques.id === givenQuestion && ques.nextStep) {
          ques.nextStep.forEach(next => {
            if (next.nextStepSelectedResponse === userSelectedValue) {
              nextQuestionsIdList = next.nextStepValue;
            }
          });
        }
      });
    });

    this.triggerClickEvent(); // This is to remove the unnecessary error message in certain devices
    return nextQuestionsIdList;
  }

  triggerClickEvent(){
    const element = document.getElementById('click-question');
    element.click();
  }

  getNestedNextQuesIdList(quesIdToFind: string, jsonToReferFromSyncService: string): string[] {
    let nextQuestionsIdList: string[] = [];
    if (jsonToReferFromSyncService === MEDICATION) {
      this.sectionsListObjForMedication.forEach(sec => {
        sec.question.forEach(ques => {
          if (ques.id === quesIdToFind) {
            nextQuestionsIdList.push(ques.id);
          }
        });
      });
    }
    else {
      this.sectionsListObj.forEach(sec => {
        sec.question.forEach(ques => {
          if (ques.id === quesIdToFind && ques.nextStep && ques.nextStep && ques.nextStep.length > 0) {
            ques.nextStep.forEach(element => {
              if (element.nextStepType === "Question" && element.nextStepValue && element.nextStepValue.length > 0) {
                element.nextStepValue.forEach(nextStepQues => {
                  nextQuestionsIdList.push(nextStepQues);
                });

              }
            });
          }
        });
      });
    }
    return nextQuestionsIdList;
  }

  getSecRecurrenceNumber(givenQuestionId: string, jsonToReferFromSyncService: string): string {
    let secRecurrence: string;
    if (jsonToReferFromSyncService === MEDICATION) {
      this.sectionsListObjForMedication.forEach(sec => {
        sec.question.forEach(ques => {
          if (ques.id === givenQuestionId) {
            secRecurrence = sec.sRecurrence;
          }
        });
      });
    } else {
      this.sectionsListObj.forEach(sec => {
        sec.question.forEach(ques => {
          if (ques.id === givenQuestionId) {
            secRecurrence = sec.sRecurrence;
          }
        });
      });
    }
    return secRecurrence;
  }

  prepareForDepQuestionsForResValueAsString(formObj: UntypedFormGroup, quesObj: LifeStyleQuestion, selectedValue: string, jsonToReferFromRec: string, indexNumberToStore: number, prefix: string) {
    if (quesObj.nextStep) {
      quesObj.nextStep.forEach(next => {
        if (next.nextStepSelectedResponse === selectedValue && next.nextStepValue && next.nextStepType !== 'File') {
          let nextQuestionIdList: string[] = next.nextStepValue;
          if (quesObj.id.includes("MDQ")) {
            let nextQuestionObjList: LifeStyleQuestion[] = this.getMedicationQuestionListForGivenIds(nextQuestionIdList, jsonToReferFromRec);
            nextQuestionObjList.forEach(nextQuestionObj => {

              let referenceQueId: string = quesObj.id;
              let backendQuestionObjForDependentQues: QuestionsToAPI = this.prepareBackendJson(formObj, nextQuestionObj, prefix);
              backendQuestionObjForDependentQues.index = (indexNumberToStore).toString();
              this.recurrenceBackendJsonList.push(backendQuestionObjForDependentQues);
              this.recursiveFunForDependentQuestionForTabSqaure(formObj, backendQuestionObjForDependentQues.responseValue, nextQuestionObj, jsonToReferFromRec, indexNumberToStore, prefix);
            });
          } else {
            let nextQuestionObjList: LifeStyleQuestion[] = this.getQuestionListForGivenIds(nextQuestionIdList, jsonToReferFromRec);
            nextQuestionObjList.forEach(nextQuestionObj => {

              let referenceQueId: string = quesObj.id;
              let backendQuestionObjForDependentQues: QuestionsToAPI = this.prepareBackendJson(formObj, nextQuestionObj, prefix);
              backendQuestionObjForDependentQues.index = (indexNumberToStore).toString();
              this.recurrenceBackendJsonList.push(backendQuestionObjForDependentQues);
              this.recursiveFunForDependentQuestionForTabSqaure(formObj, backendQuestionObjForDependentQues.responseValue, nextQuestionObj, jsonToReferFromRec, indexNumberToStore, prefix);
            });
          }
        }
      });
    }
  }

  recursiveFunForDependentQuestionForTabSqaure(formObj: UntypedFormGroup, selectedValueForMandatoryQues: any, quesObj: LifeStyleQuestion, jsonToReferFromRec: string, indexNumberToStore: number, prefix: string) {
    if (typeof selectedValueForMandatoryQues === 'string' && selectedValueForMandatoryQues && quesObj.responseValue && quesObj.responseValue.length > 0) {
      // for the values where response value can be one. like input , number, radiobtn (yes/no)
      this.prepareForDepQuestionsForResValueAsString(formObj, quesObj, selectedValueForMandatoryQues, jsonToReferFromRec, indexNumberToStore, prefix);
    }
  }

  prepareCurrentActiveFormTabSquare(formObj: UntypedFormGroup, nextQuestionObjList: LifeStyleQuestion[], indexNumberToStore: number, positionId: string, jsonSectionToRefer: string, prefix: string) {
    this.recurrenceBackendJsonList = [];
    nextQuestionObjList.forEach(recQuesObj => {
      let referenceQueId: string = recQuesObj.id;
      let recurrenceBackendJson: QuestionsToAPI = this.prepareBackendJson(formObj, recQuesObj, prefix);
      recurrenceBackendJson.index = indexNumberToStore.toString();
      this.recurrenceBackendJsonList.push(recurrenceBackendJson);
      let selectedValueForMandatoryQues = recurrenceBackendJson.responseValue;
      this.recursiveFunForDependentQuestionForTabSqaure(formObj, selectedValueForMandatoryQues, recQuesObj, jsonSectionToRefer, indexNumberToStore, prefix);

    });
    let temp = new MedicationQuestionStoreModel();
    temp.indexToSave = indexNumberToStore.toString();
    let quesIdToSetActive = prefix ? (prefix + positionId) : positionId;
    temp.medQuesId = positionId;
    temp.questionList = this.recurrenceBackendJsonList;
    this.syncService.setMedicationQuestionList(temp);
  }

  getRecurrenceListForGivenQues(quesObj: LifeStyleQuestion, prefix: string): MedicationQuestionStoreModel[] {
    let temp = this.syncService.getMedicationQuestionList();
    let recurrenceQuesListFromUIStoreForGivenQues: MedicationQuestionStoreModel[] = [];
    let quesIdToFind = prefix ? (prefix + quesObj.id) : quesObj.id;
    temp.forEach(recQues => {
      if (recQues.quesToMap === quesIdToFind) {
        recurrenceQuesListFromUIStoreForGivenQues = recQues.quesListToStore;
      }
    });
    recurrenceQuesListFromUIStoreForGivenQues.sort((a: any, b: any): number => {
      return a.indexToSave - b.indexToSave;
    });

    return recurrenceQuesListFromUIStoreForGivenQues;
  }

  getQuestionListForGivenIndex(quesObj: LifeStyleQuestion, indexValue: number): QuestionsToAPI[] {
    let temp = this.getAnswerFromStore(quesObj.id);
    let questionListForGivenIndex: QuestionsToAPI[] = [];
    if (temp && temp.questionModels && temp.questionModels.length > 0) {
      temp.questionModels.forEach(element => {
        if (element.index === indexValue.toString())
          questionListForGivenIndex.push(element);
      });
    }
    return questionListForGivenIndex;
  }

  setSelectedMedicalCondition(listOfMcCondObj: LifeStyleQuestion, selectedValue: string) {
    let urlToFetch: string;
    listOfMcCondObj.nextStep.forEach(next => {
      if (next.nextStepSelectedResponse === selectedValue) {
        urlToFetch = next.nextStepValue[0];
      }
    });
    let tempCurrentMedConToDisplayObj = new CurrentMedConToDisplay();
    tempCurrentMedConToDisplayObj.tittle = selectedValue;
    tempCurrentMedConToDisplayObj.jsonUrl = urlToFetch;
    this.syncService.setInitialQuestionJson(tempCurrentMedConToDisplayObj);
  }

  getResponseValuesFromStore(givenQuesId: string, lifeStylePayloadFromStore: UnderWritingData, index: number): QuestionsToAPI {
    let value: QuestionsToAPI;
    if (this.currentUWScreenName === 'annuitant' && lifeStylePayloadFromStore.annuitantMedicalConditions
      && lifeStylePayloadFromStore.annuitantMedicalConditions.length > 0
      && lifeStylePayloadFromStore.annuitantMedicalConditions.find(elem => elem.index === index)) {
      let questionList: QuestionsToAPI[] = lifeStylePayloadFromStore.annuitantMedicalConditions.find(elem => elem.index === index).questions;
      for (let item in questionList) {
        if (questionList[item].id === givenQuesId) {
          value = questionList[item];
          break;
        }
      }
    } else if (this.currentUWScreenName === 'dependant' && lifeStylePayloadFromStore.dependentMedicalConditions
      && lifeStylePayloadFromStore.dependentMedicalConditions.length > 0
      && lifeStylePayloadFromStore.dependentMedicalConditions.find(elem => elem.index === index)) {
      let questionList: QuestionsToAPI[] = lifeStylePayloadFromStore.dependentMedicalConditions.find(elem => elem.index === index).questions;
      for (let item in questionList) {
        if (questionList[item].id === givenQuesId) {
          value = questionList[item];
          break;
        }
      }
    }
    return value;
  }

  isPartOfWA(questionText: string): boolean{
    let isPartOfWA: boolean = false;
    let temp = questionText.replace("?", "");
    for(let itm in BRMS_WEB_ANALYTICS_CONST_LIST){
      if(BRMS_WEB_ANALYTICS_CONST_LIST[itm] === temp ||
        BRMS_WEB_ANALYTICS_CONST_LIST[itm].includes(temp)){
        isPartOfWA = true;
        break;
      }
    }
    return isPartOfWA;
  }
  makeRegex = (range): string => {
    let pattern = '';
    if (range && range !== '') {
      const rangeArray = range.replace(/ /g, '');
      switch (rangeArray) {
        case '1to9':
          pattern = '^([1-9])$';
          break;
        case '0to11':
          pattern = '^([0-9]|1[01])$';
          break;
        case '0to13':
          pattern = '^([0-9]|1[0-3])$';
          break;
        case '1to99':
          pattern = '^([1-9]|[1-8][0-9]|9[0-9])$';
          break;
        case '0to999':
          pattern = '^([0-9]|[1-8][0-9]|9[0-9]|[1-8][0-9]{2}|9[0-8][0-9]|99[0-9])$';
          break;
        case '30to302':
          pattern = '^([3-8][0-9]|9[0-9]|[12][0-9]{2}|30[0-2])$';
          break;
        case '6to628':
          pattern = '^([6-9]|[1-8][0-9]|9[0-9]|[1-5][0-9]{2}|6[01][0-9]|62[0-8])$';
          break;
        default:
          pattern = '';
          break;
      }
    }
    return pattern;
  }
  getRegexPattern(quesObjList: LifeStyleQuestion[]): string {
    let newRange;
    let pattern;
    quesObjList.forEach(quesObjList => {
      this.rangeValidationData.forEach(rangeValue => {
        if (quesObjList.responseRange) {
          let temp = quesObjList.responseRange.split("=");
          let newResponseFromJson = temp[1];
          newRange = newResponseFromJson === rangeValue.valueKey ? rangeValue.valueMin + ' to ' + rangeValue.valueMax : '';
        }

        if (newRange) {
          pattern = this.makeRegex(newRange);
        }
      })
    });
    return pattern;
  }
  isInvalidPattern = (parentForm, controlTypeQuestionList?: any): ErrorMsgModel => {
    const errormsgModalObj = new ErrorMsgModel();
    errormsgModalObj.errorMessage = '';
    errormsgModalObj.isValid = false;
    let newRange;
    if (controlTypeQuestionList) {
      controlTypeQuestionList.every(tempQuesObj => {
        this.rangeValidationData.every(rangeValue => {
          if (tempQuesObj.responseRange) {
            const temp = tempQuesObj.responseRange.split('=');
            const newResponseFromJson = temp[1];
            newRange = newResponseFromJson === rangeValue.valueKey ? rangeValue : newRange;
            const val = parentForm.get(tempQuesObj.id).value;
            if (newRange && val && !(parseInt(newRange.valueMin) <= parseInt(val)
              && parseInt(val) <= parseInt(newRange.valueMax))) {
              errormsgModalObj.isValid = true;
              // tslint:disable-next-line:max-line-length
              errormsgModalObj.errorMessage = 'Please enter a value for ' + newRange.valueKey + ' between ' + newRange.valueMin + ' and ' + newRange.valueMax;
              return false;
            }
            newRange = null;
            return true;
          }
        });
        if (errormsgModalObj.isValid) {
          return false;
        } else {
          return true;
        }
      });
    }
    return errormsgModalObj;
  }
  emitTabSquareValidationEvent() {
    let tabSquareValidation = new CustomEvent("tabSquareValidation", null);
    document.dispatchEvent(tabSquareValidation);
  }

  emitAccordionValidationEvent(formObj: UntypedFormGroup) {
    let foundInvalidAccordionList: string[] = [];
    let controlNameList: string[] = [];
    Object.keys(formObj.controls).forEach(formObjControls => {
      let isAccordPrefixAvailable = formObjControls.includes('-'); //A0-HRQ001
      if (isAccordPrefixAvailable && ( formObj.get(formObjControls) instanceof UntypedFormGroup )) {
        controlNameList.push(...Object.keys(formObj.get(formObjControls)['controls']));
      } else if (isAccordPrefixAvailable && ( formObj.get(formObjControls) instanceof UntypedFormControl )){
        controlNameList.push(formObjControls);
      }
    });

    controlNameList.forEach(ctlName => {
      let temp: string[] = ctlName.split('-');
      let count = temp.length; //A0-HRQ003-monthly
      let controlNameToSearch = temp.length === 3 ? (temp[0]+'-'+temp[1]+'.'+ctlName) : (ctlName);
      if (formObj.get(controlNameToSearch).errors) {
        let prefixOfCtlName: string = temp[0];
        foundInvalidAccordionList.push(prefixOfCtlName); //A0-HRQ001
      }
    });

    let uniqueInvalidAccordionList = foundInvalidAccordionList.filter(function (elem, index, self) {
      return index === self.indexOf(elem);
    });
    let accordionValidationEvt = new CustomEvent("accordionValidationEvt", { detail: uniqueInvalidAccordionList });
    document.dispatchEvent(accordionValidationEvt);
  }


  conversionChangesForHeight(question: LifeStyleQuestion, parent: UntypedFormGroup, errorValue: ErrorMsgModel, toggleSelected: string) {

    if (question.questionText === 'feet' && toggleSelected === 'cm') {
      this.conversionChangeObj.feetValue = null;
      if (question.responseValueByUser) {
        if (errorValue && !errorValue.isValid) {
          this.conversionChangeObj.feetValue = Number(converter.length(question.responseValueByUser).from('ft').to('cm').value.toFixed(1));
        } else {
          this.conversionChangeObj.feetValue = null;
          this.conversionChangeObj.inchValue = null;
        }
        question.responseValueByUser = '';
      }
    }
    if (question.questionText === 'inches' && toggleSelected === 'cm') {
      this.conversionChangeObj.inchValue = null;
      if (question.responseValueByUser) {
        if (errorValue && !errorValue.isValid) {
          this.conversionChangeObj.inchValue = Number(converter.length(question.responseValueByUser).from('in').to('cm').value.toFixed(1));
        } else {
          this.conversionChangeObj.feetValue = null;
          this.conversionChangeObj.inchValue = null;
        }
        question.responseValueByUser = '';
      }
    }

    if (question.questionText === 'cm') {
      if (this.conversionChangeObj.feetValue) {
        if (errorValue && !errorValue.isValid) {
          question.responseValueByUser = Math.round(this.conversionChangeObj.feetValue + this.conversionChangeObj.inchValue).toString();
        } else {
          question.responseValueByUser = null;
        }
        this.conversionChangeObj.feetValue = null;
        this.conversionChangeObj.inchValue = null;
      } else if (question.responseValueByUser && toggleSelected !== 'cm') {

        let tempNumber = Number(question.responseValueByUser);
        this.conversionChangeObj.centimeterValue = Number((tempNumber / 30.40)).toFixed(2);

        question.responseValueByUser = '';
        for (const cont in parent.controls) {
          if (parent.controls.hasOwnProperty(cont)) {
            let selectedOptionsNew = [];
            selectedOptionsNew = this.getQuestionListForGivenIds([cont], null);

            selectedOptionsNew.forEach(temp => {
              let tempFeetInch;
              const tempValue = this.conversionChangeObj.centimeterValue.toString();
              tempFeetInch = tempValue.split(".");

              if (temp.questionText === 'feet') {
                if (errorValue && !errorValue.isValid) {
                  temp.responseValueByUser = tempFeetInch[0];
                } else {
                  temp.responseValueByUser = null;
                }
              }
              if (temp.questionText === 'inches') {
                if (errorValue && !errorValue.isValid) {
                  let newInchValue;
                  newInchValue = tempFeetInch[1] === '00' ? 0 : tempFeetInch[1];
                  const convertedIncheValue = Math.round((newInchValue * 12) / 100);
                  temp.responseValueByUser = convertedIncheValue.toString();
                } else {
                  temp.responseValueByUser = null;
                }
              }
            });
          }
        }

      }
    }

  }

  conversionChangesForWeight(question: LifeStyleQuestion, parent: UntypedFormGroup, errorValue: ErrorMsgModel, toggleSelected: string) {
    if (question.questionText === 'stone' && toggleSelected === 'kgs') {
      this.conversionChangeObj.stoneValue = null;
      if (question.responseValueByUser && !parent.controls[question.id].invalid) {
        let temp: number = Number(question.responseValueByUser);
        if (errorValue && !errorValue.isValid) {
          this.conversionChangeObj.stoneValue = (temp * (6.35));
        } else {
          this.conversionChangeObj.stoneValue = null;
          this.conversionChangeObj.poundsValue = null;
        }
        question.responseValueByUser = '';
      }
    }
    if (question.questionText === 'pounds' && toggleSelected === 'kgs') {
      this.conversionChangeObj.poundsValue = null;
      if (question.responseValueByUser && !parent.controls[question.id].invalid) {
        if (errorValue && !errorValue.isValid) {
          const decimal = '0.' + question.responseValueByUser;
          this.conversionChangeObj.poundsValue = Number(decimal) * (6.35);
          // tslint:disable-next-line:max-line-length
        } else {
          this.conversionChangeObj.stoneValue = null;
          this.conversionChangeObj.poundsValue = null;
        }
        question.responseValueByUser = '';
      }

    }
    if (question.questionText === 'kgs') {
      if (this.conversionChangeObj.stoneValue && !errorValue.errorMessage) {
        if (errorValue && !errorValue.isValid) {
          question.responseValueByUser = Math.round(this.conversionChangeObj.poundsValue + this.conversionChangeObj.stoneValue).toString();
        } else {
          question.responseValueByUser = null;
        }
        this.conversionChangeObj.poundsValue = null;
        this.conversionChangeObj.stoneValue = null;

      } else if (question.responseValueByUser && !parent.controls[question.id].invalid && toggleSelected !== 'kgs') {

        let temp: number = Number(question.responseValueByUser);
        this.conversionChangeObj.kgsValue = parseFloat(Number((temp / 6.35)).toFixed(2));

        question.responseValueByUser = '';

        for (const cont in parent.controls) {
          if (parent.controls.hasOwnProperty(cont)) {
            let selectedOptionsNew = [];
            selectedOptionsNew = this.getQuestionListForGivenIds([cont], null);

            selectedOptionsNew.forEach(temp => {
              let tempStonePound;
              let tempValue = Number(this.conversionChangeObj.kgsValue);
              tempStonePound = tempValue.toString().split(".");

              if (temp.questionText === 'stone') {
                if (errorValue && !errorValue.isValid) {
                  temp.responseValueByUser = tempStonePound[0];
                } else {
                  temp.responseValueByUser = null;
                }
              }

              if (temp.questionText === 'pounds') {
                let newPoundValue;
                newPoundValue = tempStonePound[1] === '00' ? 0 : tempStonePound[1];
                const convertedPoundValue = newPoundValue > 13 ?
                  (Number(newPoundValue.substring(1, 2)) > 4 ? Number(newPoundValue.substring(0, 1)) + 1 : newPoundValue.substring(0, 1)) :
                  newPoundValue;
                if (errorValue && !errorValue.isValid) {
                  temp.responseValueByUser = convertedPoundValue.toString();
                } else {
                  temp.responseValueByUser = null;
                }
              }
            });
          }
        }

      }
    }

  }

  /* diabetes conversion*/
  conversionChangesForDiabetes(question: LifeStyleQuestion, parent: UntypedFormGroup, errorValue: ErrorMsgModel, toggleSelected: string) {

    let tempQuestion = question.responseRange ? question.responseRange.split("=") : null;
    let questionLabel = tempQuestion ? tempQuestion[1] : null;
    if (questionLabel === 'IFCC' && toggleSelected === 'DCCT (%)') {
      this.diabetesConversionChangeObj.iffcValue = null;
      if (question.responseValueByUser) {
        let temp: number = Number(question.responseValueByUser);
        let convertedValue = Number((0.09148 * temp) + 2.152).toFixed(2);
        if (errorValue && !errorValue.isValid) {
          this.diabetesConversionChangeObj.iffcValue = convertedValue.toString();
        } else {
          this.diabetesConversionChangeObj.iffcValue = null;
          this.diabetesConversionChangeObj.dcctValue = null;
        }
        question.responseValueByUser = '';
      }
    }
    if (questionLabel === 'DCCT') {
      if (this.diabetesConversionChangeObj.iffcValue) {
        let idcctConvertedValue = Number(this.diabetesConversionChangeObj.iffcValue);

        question.responseValueByUser = idcctConvertedValue.toString();

        this.diabetesConversionChangeObj.iffcValue = null;

      } else if (question.responseValueByUser && toggleSelected !== 'DCCT (%)') {

        let temp: number = Number(question.responseValueByUser);
        let convertedValue = Number((10.93 * temp) - 23.50).toFixed(2);
        if (errorValue && !errorValue.isValid) {
          this.diabetesConversionChangeObj.dcctValue = convertedValue.toString();
        }
        else {
          this.diabetesConversionChangeObj.iffcValue = null;
          this.diabetesConversionChangeObj.dcctValue = null;
        }

        question.responseValueByUser = '';

        for (const cont in parent.controls) {
          if (parent.controls.hasOwnProperty(cont)) {
            let selectedOptionsNew = [];
            selectedOptionsNew = this.getQuestionListForGivenIds([cont], null);

            selectedOptionsNew.forEach(temp => {
              let tempQuestion = temp.responseRange ? temp.responseRange.split("=") : null;
              let questionLabel = tempQuestion ? tempQuestion[1] : null;

              if (questionLabel === 'IFCC') {
                let iffcConvertedValue = Number(this.diabetesConversionChangeObj.dcctValue);
                if (errorValue && !errorValue.isValid) {
                  temp.responseValueByUser = Math.round(iffcConvertedValue);
                } else {
                  temp.responseValueByUser = null;
                }
              }
            });
          }
        }

      }
    }

  }
  sortMedicalConditions(tempMedCondList) {
    let medCondList = tempMedCondList.filter(medItem => {
      return medItem.questionSetName !== MedicalCondQuestionSet.lifestyle && medItem.questionSetName !== MedicalCondQuestionSet.adl
    });
    let lifestyleData = [...tempMedCondList.filter(med => { return med.questionSetName === MedicalCondQuestionSet.lifestyle })][0];
    let adlData = [...tempMedCondList.filter(med => { return med.questionSetName === MedicalCondQuestionSet.adl })];
    let conditionsList = [];
    conditionsList.push(lifestyleData);
    if (medCondList && medCondList.length > 0) {
      medCondList.forEach((medCond) => {
        conditionsList.push(medCond);
      });
    }
    if (adlData && adlData.length > 0) {
      conditionsList.push(adlData[0]);
    }
    return this.updateIndexMedicalConditions(conditionsList);
  }

  updateIndexMedicalConditions(conditionsList) {
    if (conditionsList && conditionsList.length > 0) {
      conditionsList = conditionsList.map((cond, ind: number) => ({...cond, index: ind}));
    }
    return conditionsList;
  }
}
